import React from "react";
import { useNavigate } from 'react-router-dom';

export const TermsAndConditions = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Blue Header */}
      <div className="bg-blue-600 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex items-center mb-4">
            <button onClick={() => navigate('/')} className="flex items-center text-white hover:text-blue-200">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Back to home
            </button>
          </div>
          <h1 className="text-4xl font-bold mb-2">Terms and Conditions</h1>
          <p className="text-blue-100 text-lg">Legal terms and conditions for using this service</p>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <p className="text-gray-500 mb-6">Last updated: June 5, 2025</p>
          
          {/* Important Notice */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
            <h3 className="text-blue-800 font-semibold mb-2">Important Notice</h3>
            <p className="text-blue-700 text-sm">
              This is a website that is dedicated to a ROBLOX group. This service is not affiliated with the UK Government, Parliament, or 
              official UK petitions system.
            </p>
          </div>

          {/* 1. Acceptance of Terms */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-4">
              By accessing and using the UK RBLX Petitions website, you accept and agree to be bound by the terms and provision 
              of this agreement.
            </p>
          </section>

          {/* 2. ROBLOX Integration Requirements */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. ROBLOX Integration Requirements</h2>
            <p className="text-gray-600 mb-4">To use this service, you must:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Have a valid ROBLOX account</li>
              <li>Be a British Citizen in the <a href="https://www.roblox.com/communities/541807/UK-United-Kingdom" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">United Kingdom</a></li>
            </ul>
          </section>

          {/* 3. Petition Guidelines */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Petition Guidelines</h2>
            <p className="text-gray-600 mb-4">When creating petitions, you agree to:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Only petition for matters within UK Government or Parliament responsibility</li>
              <li>Use respectful language and avoid offensive content</li>
              <li>Not create duplicate or spam petitions</li>
              <li>You can only create three petitions per day</li>
              <li>You must be a British Citizen in the <a href="https://www.roblox.com/communities/541807/UK-United-Kingdom" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">United Kingdom</a></li>
            </ul>
          </section>

          {/* 4. User Conduct */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. User Conduct</h2>
            <p className="text-gray-600 mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Use the service for any unlawful purpose</li>
              <li>Post content that is defamatory, discriminatory, or harmful</li>
              <li>Attempt to manipulate petition signatures or rankings</li>
              <li>Impersonate others or provide false information</li>
              <li>Interfere with the proper functioning of the website</li>
            </ul>
          </section>

          {/* 5. Account Termination */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Account Termination</h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to suspend or terminate your access to the service if you violate these terms or engage in 
              behavior deemed inappropriate. This includes disconnecting your ROBLOX account integration.
            </p>
          </section>

          {/* 6. Data and Privacy */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Data and Privacy</h2>
            <p className="text-gray-600 mb-4">
              Your use of this service is also governed by our <a href="/privacypolicy" className="text-blue-600 hover:underline">Privacy Policy</a>. We collect and process data from your ROBLOX account 
              including username, group membership, and rank information as detailed in our Privacy Policy.
            </p>
          </section>

          {/* 7. Limitation of Liability */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 mb-4">
              We provide this service "as is" without warranties of any kind. We are not liable for any damages arising from your use 
              of this service, including but not limited to data loss, service interruptions, or account issues.
            </p>
          </section>

          {/* 8. Changes to Terms */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Changes to Terms</h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your 
              continued use of the service constitutes acceptance of the modified terms.
            </p>
          </section>

          {/* 9. Contact Information */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Contact Information</h2>
            <p className="text-gray-600">
              If you have questions about these Terms and Conditions, please message pqs. on Discord.
            </p>
          </section>

          {/* Navigation Links */}
          <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">
            <a href="/" className="flex items-center text-blue-600 hover:text-blue-800">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Return to Home
            </a>
            <a href="/privacypolicy" className="text-blue-600 hover:text-blue-800">
              View Privacy Policy →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

// Term Management Component (Government Only)
